module.exports = __webpack_public_path__ + "media/images/vr/promo-experiencias-section-bg-0a7f3d601a7d4dddc238101052c5d6fd.jpg";